import Api from './api';

const BalancoService = {
    cadastro: async (params) => {
        const response = await Api.post('/restrito/balanco/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },

    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/restrito/balanco/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    numBalancos: async (params) => {
        return Api({
            method: 'get',
            url: '/restrito/balanco/numbalancos',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    deletar: (id) => {
        Api.delete(`/restrito/balanco/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    balancoEdit: async (id) => {
        const response = await Api.get(`/restrito/balanco/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editar: async (id, params) => {
        const response = await Api.put(`/restrito/balanco/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/restrito/balanco/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    }
}

export default BalancoService;